import { deriveSimPermissions } from "@/features/network-topology/engine";
import type { NetworkNode } from "@/features/network-topology/types";
import type { SimulationContext } from "@/features/simulation/types";

/**
 * network 状態から SimulationContext を構築する純粋関数。
 *
 * tick 毎に呼ばれるので、`deriveSimPermissions` の O(n) を許容できる粒度
 * (n=ノード数。既定で 12 程度、せいぜい数十)。
 */
export function buildSimContext(nodes: readonly NetworkNode[]): SimulationContext {
  return { permissions: deriveSimPermissions(nodes) };
}
